import script from "./ActionButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionButtons.vue?vue&type=script&setup=true&lang=js"

import "./ActionButtons.vue?vue&type=style&index=0&id=6a0b19da&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a0b19da"]])

export default __exports__